import { bottomNavigationActionClasses } from '@mui/material'
import { type ComponentsOverrides, type Theme } from '@mui/material/styles'
import { ellipsis } from 'polished'

export const overridesBottomNavigation = (theme: Theme): ComponentsOverrides['MuiBottomNavigation'] => ({
  root: {
    backgroundColor: theme.customPalette.background.paper,
  },
})

export const overridesBottomNavigationAction = (theme: Theme): ComponentsOverrides['MuiBottomNavigationAction'] => ({
  root: {
    color: theme.palette.text.primary,
    fill: theme.palette.text.primary,
    [`&.${bottomNavigationActionClasses.selected}`]: {
      color: theme.palette.primary.dark,
      fill: theme.palette.primary.dark,
    },
  },
  label: {
    ...ellipsis(),
  },
})
